import React from "react"
import './index.css'

interface ContainerProps {
    children: React.ReactNode;
}

export default function MainContainer(props: ContainerProps) {
    const { children } = props;
    return (
        <div className="main-container">
            {children}
        </div>
    )
}